import Calc from "../../../../helper/calculate.helper";
const { $ } = window;

const Helper = {
  styleFormatData: res => {
    var dat = res;
    let dates = [];
    let styles = [];
    let ASTC = [];

    var scn_port = dat.getPortfolioData;

    $.each(scn_port, function(k, v) {
      if (dates.indexOf(v.dt) == -1) {
        dates.push(v.dt);
      }

      if (styles.indexOf(v.style) == -1) {
        styles.push(v.style);
      }

      if (ASTC.indexOf(v.fund_asset_class_focus) == -1) {
        ASTC.push(v.fund_asset_class_focus);
      }
    });

    var seriesOptions = [];
    $.each(styles, (k, v) => {
      var sdata = Calc.getDataForstac(dates, v, scn_port);
      seriesOptions.push({
        name: v,
        data: sdata
      });
    });
    return seriesOptions;
  },
  assetFormatData: dat => {
    let dates = [];
    let styles = [];
    let ASTC = [];

    var scn_port = dat.getPortfolioData;

    $.each(scn_port, function(k, v) {
      if (dates.indexOf(v.dt) == -1) {
        dates.push(v.dt);
      }

      if (styles.indexOf(v.style) == -1) {
        styles.push(v.style);
      }

      if (ASTC.indexOf(v.fund_asset_class_focus) == -1) {
        ASTC.push(v.fund_asset_class_focus);
      }
    });
    var seriesOptionsA = [];
    $.each(ASTC, function(k, v) {
      var sdata = Calc.getDataForstacA(dates, v, scn_port);
      seriesOptionsA.push({
        name: v,
        data: sdata
      });
    });
    return seriesOptionsA;
  }
};

export default Helper;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/helper.js